import { normalize, schema } from "normalizr";

import { removeEmptyKeys } from "./common";
import { toCents } from "./price";
import { currencyList } from "@const/postManagement";

/**
 * Create subscription model
 * @param {object} model
 */
export const createSubscriptionModel = async (model) => {
  const {
    id,
    imageId,
    title,
    description,
    priceType,
    monthlyPrice,
    semiAnnualPrice,
    annualPrice,
    includedPostIds,
    excludedPostIds,
    selectType,
  } = model;

  const subscriptionModel = {
    id,
    title: title?.trim(),
    description: description?.trim(),
    priceType: id ? null : priceType,
  };

  subscriptionModel.imageId = imageId;

  const isInUSD = priceType === currencyList[0].value;
  const convert = isInUSD ? toCents : (value) => value;

  if (!id) {
    subscriptionModel.monthlyPrice = Number(convert(monthlyPrice));
    subscriptionModel.semiAnnualPrice = Number(convert(semiAnnualPrice));
    subscriptionModel.annualPrice = Number(convert(annualPrice));
  }

  subscriptionModel.selectType = selectType;
  subscriptionModel.excludedPostIds = excludedPostIds;
  subscriptionModel.includedPostIds = includedPostIds;

  return removeEmptyKeys(subscriptionModel);
};

export const normalizeSubscriptionArray = (originalSubscription) => {
  const authorSchema = new schema.Entity("authors");
  const subscriptionsSchema = new schema.Entity("subscriptions", {
    author: authorSchema,
  });

  const subscriptions = new schema.Array(subscriptionsSchema);

  return normalize(originalSubscription, subscriptions);
};

export const normalizeDonationArray = (originalSubscription) => {
  const authorSchema = new schema.Entity("authors");
  const postSchema = new schema.Entity("post", {
    authors: authorSchema,
  });

  const paymentSchema = new schema.Entity("payments", {
    post: postSchema,
    recipient: authorSchema,
    sender: authorSchema,
  });
  const payments = new schema.Array(paymentSchema);

  return normalize(originalSubscription, payments);
};

export const normalizeSubscription = (originalSubscription) => {
  const authorSchema = new schema.Entity("authors");
  const subscriptionsSchema = new schema.Entity("subscriptions", {
    author: authorSchema,
  });

  return normalize(originalSubscription, subscriptionsSchema);
};
